import React, { useRef, useState } from 'react';
import { Card, Form, Button, Alert } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';
import { Link } from 'react-router-dom';
import CenteredContainer from './CenteredContainer';

export default function ForgotPassword() {
    const emailRef = useRef();
    const { forgotPassword } = useAuth();
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');

    async function handleSubmit(e) {
        e.preventDefault();

        try {
            setError('');
            setLoading(true);
            await forgotPassword(emailRef.current.value);
            setMessage('Check your inbox for further instructions');
        }
        catch(e) {
            setError('Failed to reset password');
        }

        setLoading(false);

    }

    return (
        <CenteredContainer>
            <Card bg="dark" variant="dark">
                <Card.Body>
                    <h2 className="text-center mb-4 text-white">Log In</h2>
                    { error && <Alert variant="danger">{error}</Alert> }
                    { message && <Alert variant="success">{message}</Alert> }
                    <Form onSubmit={handleSubmit}>
                        <Form.Group id="email">
                            <Form.Label className="text-white">Password Reset</Form.Label>
                            <Form.Control type="email" ref={emailRef} required />
                        </Form.Group>
                        <Button disabled={loading} className="w-100 text-white" type="submit">
                            Reset Password
                        </Button>
                    </Form>
                    <div className="w-100 text-center mt-3">
                        <Link to="/login">Log In</Link>
                    </div>
                    <div className="w-100 text-center mt-2 text-white">
                        Need an account? <Link to="/signup">Sign Up</Link>
                    </div>
                </Card.Body>
            </Card>
        </CenteredContainer>
    )
}
